import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import arivu from "../../assets/logo/ArivuHeader.png";
import { PageTitleContainer } from "../../components/container/PageTitleContainer";
import { DPP } from "../../db_access/dpp";
import muiSytle from "../../style/components-style/muiStyle";
import { dpp_format } from "../Products/DPP/ProductDPP_Format";
import ProductDPP_Preview from "../Products/DPP/ProductDPP_Preview";
const DPP_View_Pending = () => {
  const { dpp_id } = useParams();
  const [dpp, setDPP] = useState(
    dpp_format.reduce((acc, item) => {
      acc[item.field] = item.default;
      return acc;
    }, {})
  );
  const [photo, setPhoto] = useState();
  const [photoPreview, setPhotoPreview] = useState();
  const getPassport = () => {
    DPP.get(dpp_id)
      .then((res) => res.json())
      .then((data) => {
        setDPP({ ...dpp, ...data[0] });
      });
  };
  const getPhoto = () => {
    DPP.get_photo(dpp_id)
      .then((res) => (res.ok ? res.blob() : undefined))
      .then((f) => setPhoto(f));
  };
  const buttonCustomize = (label, Icon, onClick) => (
    <Button
      onClick={onClick}
      sx={{
        color: "#166534",
        textTransform: "none",
        "&:hover": { backgroundColor: "rgba(23, 163, 74, 0.2)" },
        fontFamily: "Poppins",
      }}
      startIcon={<Icon />}>
      {label}
    </Button>
  );
  useEffect(() => console.log(dpp), [dpp]);
  useEffect(() => console.log(dpp_id), [dpp_id]);
  useEffect(() => getPassport(), [dpp_id]);
  useEffect(() => getPhoto(), [dpp_id]);
  useEffect(() => {
    if (photo) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(photo);
    } else {
      setPhotoPreview(undefined);
    }
  }, [photo]);
  return (
    <Box sx={{ padding: 5 }}>
      <PageTitleContainer>
        <Box>
          <Box>
            <Typography variant="Page Title">Digital Product Passport - View Pending</Typography>
          </Box>
          <Box>
            <Typography variant="Page Subtitle">EU Regulation Compliant DPP</Typography>
          </Box>
        </Box>
        <Box>
          <img src={arivu} height={"50px"} />
        </Box>
      </PageTitleContainer>
      <ProductDPP_Preview dpp={dpp} photoPreview={photoPreview} />
    </Box>
  );
};
export default DPP_View_Pending;
